<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
        <BookingsTable
          v-if="triedLoad === true"
          :bookingsFilter="activeFilter"
          :items="items"
          :total-items="totalItems"
          :page-size="pageSize"
          @update:filter="onUpdateFilter"
          @reset="resetFilter"
        />
      </transition>
    </CCol>
    <CSpinner style="display:block;position:fixed;top:50%;left:50%" v-if="items.length == 0 && triedLoad === false" color="primary"/>
  </CRow>
</template>

<script>
import axios from "axios";
import { defaultPaymentStatuses } from '@/common';
import { getYYYYMMDDFromDateTimeString } from '@/utils/utils'
import BookingsTable from "./BookingsTable.vue";

export default {
  name: "Bookings",
  components: {
    BookingsTable
  },
  data() {
    return {
      items: [],
      activePage: 1,
      totalItems: 0,
      DEFAULT_ITEMS_PER_PAGE: 20,
      pageSize: this.DEFAULT_ITEMS_PER_PAGE,
      bookingData: [],
      bookings: [],
      fields: [
        "bookingNumber",
        "bookingDates",
        "customer",
        "guestNames",
        "createDate",
        "state",
        "DETAILS",
      ],
      experienceId: "00000000-0000-0000-0000-000000000000",
      defaultFilter: {
        paymentStatusValues: defaultPaymentStatuses,
      },
      activeFilter: this.defaultFilter,
      triedLoad : false,
      //Alert
      alertType: "danger",
      message: null,
    };
  },
  computed: {},
  methods: {
    getList({ pageNumber = 1, pageSize, search, createdFrom, createdTo, startDate, endDate, experienceId, paymentStatusValues, sort } = {}) {
      let self = this;
      const params = {
        pageNumber,
        pageSize: pageSize || this.DEFAULT_ITEMS_PER_PAGE,
        search,
        createdFrom,
        createdTo,
        startDate,
        endDate,
        experienceId,
        paymentStatusValues: paymentStatusValues ?? this.defaultFilter.paymentStatusValues,
        sort
      };
      const searchParamsStr = Object.keys(params)
        .filter((key) => params[key] !== undefined && params[key] !== null)
        .map((key) => `${key}=${params[key]}`)
        .join("&");
      axios.get(this.$apiAdress + `/v1/Booking/Search?${searchParamsStr}`)
        .then(function (response) {
          const bookings = response.data.data;
          const newItems = bookings.map((booking) => {
            booking.bookingNumber = booking.bookingNumber;
            booking.fullName =
              booking.customer.firstName + " " + booking.customer.lastName;
            booking.bookingDates =
              getYYYYMMDDFromDateTimeString(booking.startDate) +
              " - " +
              getYYYYMMDDFromDateTimeString(booking.endDate);
            booking.createDate = new Date(booking.createDate).toISOString().split("T")[0] + " " + new Date(booking.createDate).toLocaleTimeString(); // TODO - time is wrong if user in different time zone
            booking.state = booking.state;
            return booking;
          });
          self.items = newItems;
          self.totalItems = response.data.totalRecords;
          self.activePage = response.data.pageNumber;
          self.triedLoad = true;
          self.activeFilter = params;
          self.pageSize = params.pageSize;
        })
        .catch(function (error) {
          self.alertType = "danger";
          setTimeout(function () {
            self.message = null;
          }, 10000);
          self.message = error;
        });
    },
    onUpdateFilter(filter) {
      this.getList(filter);
    },
    getListWithDefaultValues() {
      this.getList(this.defaultFilter);
    },
    resetFilter(keepFilterObj = {}) {
      const newFilter = { ...this.defaultFilter, ...keepFilterObj };
      this.getList(newFilter);
    },
  },
  mounted: function () {
    this.getListWithDefaultValues();
  },
};
</script>